<div class="px-5 border-top"></div>

<div class="row mt-3">

  <div class="col-md-4">
    <mat-form-field class="col-sm-12">
      <input matInput placeholder="Nombre:" [value]="currentEmployee.displayName" readonly>
    </mat-form-field>
  </div>

  <div class="col-md-4">
    <mat-form-field class="col-sm-12">
      <input matInput placeholder="Departamento:" [value]="currentEmployee.workInformation.department.departmentName"
        readonly>
    </mat-form-field>
  </div>

  <div class="col-md-4">
    <mat-form-field class="col-sm-12">
      <input matInput placeholder="RFC:" [value]="currentEmployee.taxationIdentificationNumber" readonly>
    </mat-form-field>
  </div>

</div>

<div class="row">

  <div class="col-md-4">
    <mat-form-field class="col-sm-12">
      <input matInput placeholder="Número De Colaborador:" [value]="currentEmployee.workInformation.employeeNumber"
        readonly>
    </mat-form-field>
  </div>

  <div class="col-md-4">
    <mat-form-field class="col-sm-12">
      <input matInput placeholder="ID Departamento:" [value]="currentEmployee.workInformation.department.departmentID"
        readonly>
    </mat-form-field>
  </div>

</div>

<div *ngIf="showMessage">

  <div class="row mt-4 mb-4">
    <div class="col-md-12 text-center noActions">
      <h5 class="mt-1">Fondo De Ahorro</h5>
      <mat-icon aria-hidden="true">check</mat-icon>
      <h5>No existen datos en los acumulados del colaborador para este ciclo</h5>
    </div>
  </div>

</div>

<div *ngIf="!showMessage">
  <div *ngIf="type === 'FAL'">
    <div *ngIf="total > 0; else saldo">
      <div class="row mt-3">
        <div class="col-md-12 col-sm-12">
          <h5 class="mb-4 text-center text-uppercase">Estado de cuenta fondo de ahorro largo</h5>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-md-2 col-sm-2 mx-3">
          <mat-form-field>
            <mat-select placeholder="Años Anteriores:" (selectionChange)="selectedPeriodChange($event)"
              [value]="selectedYear">
              <mat-option>Seleccione Un Año</mat-option>
              <mat-option *ngFor="let year of pastYears" [value]="year">
                {{year}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <ng-template #desktopFAL>

        <div class="row px-3">

          <div class="col-md-4 border d-flex align-items-center justify-content-center bg-report-header text-white">
            Concepto
          </div>

          <div class="col-md-4 border-top border-bottom bg-report-header text-white">
            <div class="row border-bottom">
              <div class="col-md-12 d-flex justify-content-center">Aportación del Año {{selectedYear}}</div>
            </div>
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">Empresa</div>
              <div class="col-md-6 d-flex justify-content-center">Colaborador</div>
            </div>
          </div>

          <div class="col-md-4 border bg-report-header text-white">
            <div class="row border-bottom">
              <div class="col-md-12 d-flex justify-content-center">Total Acumulado</div>
            </div>
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">Empresa</div>
              <div class="col-md-6 d-flex justify-content-center">Colaborador</div>
            </div>
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right d-flex align-items-center justify-content-center">
            Saldo Años Anteriores
          </div>

          <div class="col-md-4">
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">&nbsp;</div>
              <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
            </div>
          </div>

          <div class="col-md-4 border-left border-right">
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">$ {{totalCompanyPastYears | number:
                '.2-2'}}
              </div>
              <div class="col-md-6 d-flex justify-content-center"> $ {{totalEmployeePastYears | number: '.2-2'}}</div>
            </div>
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div
            class="col-md-4 border-left border-right d-flex align-items-center justify-content-center bg-report-header text-white">
            Aportaciones Año {{selectedYear}}
          </div>

          <div class="col-md-4 bg-light">
            <div class="row">
              <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
              <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
            </div>
          </div>

          <div class="col-md-4 border-right bg-light">
            <div class="row">
              <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
              <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
            </div>
          </div>

        </div>

        <div class="row px-3 border-bottom" *ngFor="let item of payrollContributionArray">

          <div class="col-md-4 border-left border-right d-flex align-items-center justify-content-center">
            {{item.date}}
          </div>

          <div class="col-md-4">
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">$ {{item.companyAmount | number: '.2-2'}}
              </div>
              <div class="col-md-6 d-flex justify-content-center">$ {{item.employeeAmount | number: '.2-2'}}</div>
            </div>
          </div>

          <div class="col-md-4 border-left border-right bg-light">
            &nbsp;
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right text-right" style="background: #E1EDF9;">
            Total Aportaciones {{selectedYear}}
          </div>

          <div class="col-md-4" style="background: #E1EDF9;">
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">$
                {{totalCompanyCurrentYear | number: '.2-2'}}</div>
              <div class="col-md-6 d-flex justify-content-center">$ {{totalEmployeeCurrentYear | number: '.2-2'}}</div>
            </div>
          </div>

          <div class="col-md-4 border-left border-right" style="background: #E1EDF9;">
            &nbsp;
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right text-right">
            Total Aportaciones Acumulados
          </div>

          <div class="col-md-4 bg-light">
            &nbsp;
          </div>

          <div class="col-md-4 border-left border-right">
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">$ {{totalCompany | number: '.2-2'}}</div>
              <div class="col-md-6 d-flex justify-content-center">$ {{totalEmployee | number: '.2-2'}}</div>
            </div>
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right text-right">
            Suma Total Aportaciones
          </div>

          <div class="col-md-4 bg-light">
            &nbsp;
          </div>

          <div class="col-md-4 border-left border-right text-center">
            $ {{total | number: '.2-2'}}
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right text-right">
            Rendimientos Acumulados
          </div>

          <div class="col-md-4 bg-light">
            &nbsp;
          </div>

          <div class="col-md-4 border-left border-right text-center">
            $ {{sura | number: '.2-2'}}
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right text-right">
            Liquidación Con Rendimientos
          </div>

          <div class="col-md-4 bg-light">
            &nbsp;
          </div>

          <div class="col-md-4 border-left border-right text-center">
            $ {{totalPlusInvestment | number: '.2-2'}}
          </div>

        </div>
        <!--div class="row px-3 border-bottom">

        <div class="col-md-4 border-left border-right text-right">
          Rendimiento Generado en el año
        </div>

        <div class="col-md-4 text-center">
          $ {{suraYear | number: '.2-2'}}
          <div class="tooltip-main" data-toggle="tooltip" data-placement="top" title="Total rendimiento del año vigente o consultado">
            <span class="tooltip-qm">?</span>
          </div>
        </div>

        <div class="col-md-4 border-right bg-light">
          &nbsp;
        </div>

      </div-->

        <div class="row px-3 border-bottom">
          <div class="col-md-12 bg-report-header text-white d-flex align-items-center justify-content-end">
            <span style="font-size:10pt;">Nota: Los rendimientos están actualizados al dia de hoy y pueden subir o bajar
              diariamente dependiendo de condiciones no sujetas a nuestro control.</span>
          </div>
        </div>
      </ng-template>

      <div *ngIf="isHandset$ | async; else desktopFAL">
        <div class="bb-resume">
          <div>
            <span>Acumulado empresa:</span>
            <span>$ {{totalCompany | number: '.2-2'}}</span>
          </div>
          <div>
            <span>Acumulado colaborador:</span>
            <span>$ {{totalEmployee | number: '.2-2'}}</span>
          </div>
          <div>
            <span>Rendimientos Acumulados:</span>
            <span>$ {{sura | number: '.2-2'}}</span>
          </div>
          <div>
            <span>Total acumulado:</span>
            <span>$ {{totalPlusInvestment | number: '.2-2'}}</span>
          </div>
        </div>

        <div class="bb-past-years">
          <div class="bb-subtitle">Saldo Años Anteriores</div>
          <div class="bb-resume">
            <div>
              <span>Colaborador:</span>
              <span>$ {{totalEmployeePastYears | number: '.2-2'}}</span>
            </div>
            <div>
              <span>Empresa:</span>
              <span>$ {{totalCompanyPastYears | number: '.2-2'}}</span>
            </div>
          </div>
        </div>

        <div class="bb-curren-year">
          <div class="bb-subtitle">Aportaciones Año {{currentPeriodDates}}</div>
          <div class="bb-resume">
            <div>
              <span>Colaborador:</span>
              <span>$ {{totalEmployeeCurrentYear | number: '.2-2'}}</span>
            </div>
            <div>
              <span>Empresa:</span>
              <span>$ {{totalCompanyCurrentYear | number: '.2-2'}}</span>
            </div>
          </div>
        </div>

        <div class="bb-period bb-center-text"> Aportaciones del año {{currentPeriodDates}}</div>

        <div class="bb-past-years">
          <div *ngFor="let item of payrollContributionArray">
            <div class="bb-subtitle">{{item.date}}</div>
            <div class="bb-resume">
              <div>
                <span>Colaborador:</span>
                <span>$ {{item.employeeAmount | number: '.2-2'}}</span>
              </div>
              <div>
                <span>Empresa:</span>
                <span>$ {{item.companyAmount | number: '.2-2'}}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <ng-template #saldo>
      <div class="row mt-4 mb-4">
        <div class="col-md-12 text-center noActions">
          <h5 class="mt-1">Fondo De Ahorro Largo </h5>
          <mat-icon aria-hidden="true">check</mat-icon>
          <h5>No existen datos en los acumulados del colaborador por el momento</h5>
        </div>
      </div>
    </ng-template>
  </div>

  <div *ngIf="shouldShowPast">

    <div *ngIf="type === 'FAC'">

      <div class="row mt-3">
        <div class="col-md-12">

          <div class="text-right">
            RFC: <span class="pl-5">{{currentEmployee.taxationIdentificationNumber}}</span>
          </div>

          <h5 class="mb-4 text-center text-uppercase">Estado de cuenta fondo de ahorro corto</h5>

        </div>
      </div>

      <ng-template #desktopFACTrue>

        <div class="row px-3 mt-5">

          <div class="col-md-4 border d-flex align-items-center justify-content-center bg-report-header text-white">
            Concepto
          </div>

          <div class="col-md-4 border-top border-bottom bg-report-header text-white">
            <div class="row border-bottom">
              <div class="col-md-12 d-flex justify-content-center">Aportación del Ciclo {{currentPeriodDates}}</div>
            </div>
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">Empresa</div>
              <div class="col-md-6 d-flex justify-content-center">Colaborador</div>
            </div>
          </div>

          <div class="col-md-4 border bg-report-header text-white">
            <div class="row border-bottom">
              <div class="col-md-12 d-flex justify-content-center">Liquidación Parcial</div>
            </div>
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">Empresa</div>
              <div class="col-md-6 d-flex justify-content-center">Colaborador</div>
            </div>
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div
            class="col-md-4 border-left border-right d-flex align-items-center justify-content-center bg-report-header text-white">
            Aportaciones Año {{currentPeriodDates}}
          </div>

          <div class="col-md-4 bg-light">
            <div class="row">
              <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
              <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
            </div>
          </div>

          <div class="col-md-4 border-right bg-light border-right">
            <div class="row">
              <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
              <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
            </div>
          </div>

        </div>

        <div class="row px-3 border-bottom" *ngFor="let item of payrollContributionArray">

          <div class="col-md-4 border-left border-right d-flex align-items-center justify-content-center">
            {{item.date}}
          </div>

          <div class="col-md-4">
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">$ {{item.companyAmount | number: '.2-2'}}
              </div>
              <div class="col-md-6 d-flex justify-content-center">$ {{item.employeeAmount | number: '.2-2'}}</div>
            </div>
          </div>

          <div class="col-md-4 border-left border-right bg-light">
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">$ {{item.companyWithdraw | number:
                '.2-2'}}
              </div>
              <div class="col-md-6 d-flex justify-content-center border-right">$ {{item.employeeWithdraw | number:
                '.2-2'}}</div>
            </div>
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left  text-right">
            &nbsp;
          </div>

          <div class="col-md-4  bg-light">
            &nbsp;
          </div>
          <div class="col-md-4  bg-light border-right">
            &nbsp;
          </div>

        </div>

        <!-- nuevo anexo rendimientos FAC-->
        <div class="row px-3 border-bottom" style="background: #E1EDF9;">

          <div class="col-md-4 border-left border-right text-right">
            <b>Total de Aportaciones</b>
          </div>
          <div class="col-md-4 d-flex border-right justify-content-center"><strong>$
              {{periodTotalCompany | number: '.2-2'}}</strong></div>
          <div class="col-md-4 d-flex justify-content-center"><strong>$
              {{periodTotalEmployee | number: '.2-2'}}</strong>
          </div>

        </div>
        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right text-right">
            Suma Total Aportaciones
          </div>

          <div class="col-md-4 bg-light">
            &nbsp;
          </div>

          <div class="col-md-4 border-left border-right text-center">
            $ {{totalPeriod | number: '.2-2'}}
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right text-right">
            Rendimientos
          </div>

          <div class="col-md-4 bg-light">
            &nbsp;
          </div>

          <div class="col-md-4 border-left border-right text-center">
            $ {{suraShort | number: '.2-2'}}
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right text-right">
            Liquidación Con Rendimientos
          </div>

          <div class="col-md-4 bg-light">
            &nbsp;
          </div>

          <div class="col-md-4 border-left border-right text-center">
            <b>$ {{totalShortInvestment | number: '.2-2'}}</b>
          </div>

        </div>


        <div class="row px-3 border-bottom">
          <div class="col-md-12 bg-report-header text-white d-flex align-items-center justify-content-end">
            <span style="font-size:10pt;">Nota: Los rendimientos están actualizados al dia de hoy y pueden subir o bajar
              diariamente dependiendo de condiciones no sujetas a nuestro control.</span>&nbsp;
          </div>
        </div>
      </ng-template>

      <div *ngIf="isHandset$ | async; else desktopFACTrue">
        <div class="bb-resume">
          <div>
            <span>Acumulado empresa:</span>
            <span>$ {{periodTotalCompany | number: '.2-2'}}</span>
          </div>
          <div>
            <span>Acumulado colaborador:</span>
            <span>$ {{periodTotalEmployee | number: '.2-2'}}</span>
          </div>
          <div>
            <span>Total acumulado:</span>
            <span>$ {{totalPeriod | number: '.2-2'}}</span>
          </div>
        </div>

        <div class="bb-period bb-center-text"> Aportación del Ciclo {{currentPeriodDates}} </div>

        <div class="bb-cycle">
          <div *ngFor="let item of payrollContributionArray">
            <div class="bb-subtitle">{{item.date}}</div>
            <div class="bb-resume">
              <div>
                <span>Colaborador:</span>
                <span>$ {{item.employeeAmount | number: '.2-2'}}</span>
              </div>
              <div>
                <span>Empresa:</span>
                <span>$ {{item.companyAmount | number: '.2-2'}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="bb-period bb-center-text"> Liquidación parcial </div>

        <div class="bb-cycle">
          <div *ngFor="let item of payrollContributionArray">
            <div class="bb-subtitle">{{item.date}}</div>
            <div class="bb-resume">
              <div>
                <span>Colaborador:</span>
                <span>$ {{item.employeeWithdraw | number: '.2-2'}}</span>
              </div>
              <div>
                <span>Empresa:</span>
                <span>$ {{item.companyWithdraw | number: '.2-2'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div *ngIf="!shouldShowPast">

    <div *ngIf="type === 'FAC' ">

      <div class="row mt-3">
        <div class="col-md-12">

          <div class="text-right">
            RFC: <span class="pl-5">{{currentEmployee.taxationIdentificationNumber}}</span>
          </div>

          <h5 class="mt-1 text-center">{{companyName}}</h5>
          <h5 class="mb-4 text-center text-uppercase">Estado de cuenta fondo de ahorro corto</h5>

        </div>
      </div>

      <ng-template #desktopFACTrueDontShow>

        <div class="row px-3 mt-5">

          <div class="col-md-4 border d-flex align-items-center justify-content-center bg-report-header text-white">
            Concepto
          </div>

          <div class="col-md-8 border-top border-bottom bg-report-header text-white">
            <div class="row border-bottom">
              <div class="col-md-12 d-flex justify-content-center">Aportación del Ciclo {{currentPeriodDates}}</div>
            </div>
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">Empresa</div>
              <div class="col-md-6 d-flex justify-content-center">Colaborador</div>
            </div>
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div
            class="col-md-4 border-left border-right d-flex align-items-center justify-content-center bg-report-header text-white">
            Aportaciones Año {{currentPeriodDates}}
          </div>

          <div class="col-md-8 bg-light border-right">
            <div class="row">
              <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
              <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
            </div>
          </div>

        </div>

        <div class="row px-3 border-bottom" *ngFor="let item of payrollContributionArray">

          <div class="col-md-4 border-left border-right d-flex align-items-center justify-content-center">
            {{item.date}}
          </div>

          <div class="col-md-8">
            <div class="row">
              <div class="col-md-6 d-flex border-right justify-content-center">$ {{item.companyAmount | number: '.2-2'}}
              </div>
              <div class="col-md-6 d-flex justify-content-center border-right">$ {{item.employeeAmount | number:
                '.2-2'}}</div>
            </div>
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left  text-right">
            &nbsp;
          </div>

          <div class="col-md-4  bg-light">
            &nbsp;
          </div>
          <div class="col-md-4  bg-light border-right">
            &nbsp;
          </div>

        </div>

        <!-- nuevo anexo rendimientos FAC-->
        <div class="row px-3 border-bottom" style="background: #E1EDF9;">

          <div class="col-md-4 border-left border-right text-right">
            <b>Total de Aportaciones</b>
          </div>
          <div class="col-md-4 d-flex border-right justify-content-center"><strong>$
              {{periodTotalCompany | number: '.2-2'}}</strong></div>
          <div class="col-md-4 d-flex justify-content-center"><strong>$
              {{periodTotalEmployee | number: '.2-2'}}</strong>
          </div>

        </div>
        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right text-right">
            Suma Total Aportaciones
          </div>

          <div class="col-md-4 bg-light">
            &nbsp;
          </div>

          <div class="col-md-4 border-left border-right text-center">
            $ {{totalPeriod | number: '.2-2'}}
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right text-right">
            Rendimientos
          </div>

          <div class="col-md-4 bg-light">
            &nbsp;
          </div>

          <div class="col-md-4 border-left border-right text-center">
            $ {{suraShort | number: '.2-2'}}
          </div>

        </div>

        <div class="row px-3 border-bottom">

          <div class="col-md-4 border-left border-right text-right">
            Liquidación Con Rendimientos
          </div>

          <div class="col-md-4 bg-light">
            &nbsp;
          </div>

          <div class="col-md-4 border-left border-right text-center">
            <b>$ {{totalShortInvestment | number: '.2-2'}}</b>
          </div>

        </div>

        <div class="row px-3 border-bottom">
          <div class="col-md-12 bg-report-header text-white d-flex align-items-center justify-content-end">
            <span style="font-size:10pt;">Nota: Los rendimientos están actualizados al dia de hoy y pueden subir o bajar
              diariamente dependiendo de condiciones no sujetas a nuestro control.</span>&nbsp;
          </div>
        </div>
      </ng-template>

      <div *ngIf="isHandset$ | async; else desktopFACTrueDontShow">
        <div class="bb-resume">
          <div>
            <span>Acumulado empresa:</span>
            <span>{{periodTotalCompany | number: '.2-2'}}</span>
          </div>
          <div>
            <span>Acumulado colaborador:</span>
            <span>{{periodTotalEmployee | number: '.2-2'}}</span>
          </div>
          <div>
            <span>Total acumulado:</span>
            <span>$ {{totalPeriod | number: '.2-2'}}</span>
          </div>
        </div>

        <div class="bb-period bb-center-text"> Periodo </div>

        <div class="bb-past-years">
          <div *ngFor="let item of payrollContributionArray">
            <div class="bb-subtitle">{{item.date}}</div>
            <div class="bb-resume">
              <div>
                <span>Colaborador:</span>
                <span>$ {{item.employeeAmount | number: '.2-2'}}</span>
              </div>
              <div>
                <span>Empresa:</span>
                <span>$ {{item.companyAmount | number: '.2-2'}}</span>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>

  <div class="row my-5">

    <div class="col-md-4 offset-md-8" *ngIf="downloadURLLink; else noLink">
      <a class="btn btn-primary btn-block text-white" [href]="downloadURLLink" target="_blank">Ver Reglamento</a>
    </div>

    <ng-template #noLink>
      <div class="col-md-4  offset-md-8">
        <div class="btn btn-primary btn-block text-white">No se ha definido un reglamento</div>
      </div>
    </ng-template>

  </div>

</div>